import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePagination } from './logic';
import './styles.scss';
import { returnNumberByLang } from '../../helper/CommonFunctions';
import { useTranslation } from 'react-i18next';

const CustomPagination = props => {
    const { t } = useTranslation();

    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        className
    } = {
        onPageChange: props.onPageChange,
        totalCount: props.totalPage,
        currentPage: props.currentPage,
        pageSize: 1,
        className: "pagination-bar"
    };

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    const navigate = useNavigate();
    const { search, pathname } = useLocation();

    const [page, setPage] = useState(null);
    const [initialLoad, setInitialLoad] = useState(false);

    const DOTS = 'DOTS';
    const keys = ['page', 'pid', 'lepk', 'lesk', 'legsipk', 'legsisk'];

    const setQueryParams = (queryString) => {
        const url = new URLSearchParams(search);
        url.forEach((value, key) => {
            if (!keys.includes(key)) {
                queryString = queryString.concat(`&${key}=${value}`);
            }
        });

        navigate({
            pathname: pathname,
            search: queryString
        });
    };

    const dynamoQuerySetter = (page) => {
        const q = props.queryList[page];
        setQueryParams(`?lepk=${q.lepk}&lesk=${q.lesk}&legsipk=${q.legsipk}&pid=${page}&legsisk=${q.legsisk}`);
    };

    useEffect(() => {
        const url = new URLSearchParams(search);
        if (!props.dynamo) {
            const pageNum = Number(url.get('page')) || 1;
            setQueryParams(`?page=${Number(url.get('page')) || 1}`)
            setPage(pageNum);
        } else {
            console.log('page not')
            setPage({
                lepk: url.get('lepk'),
                lesk: url.get('lesk'),
                legsipk: url.get('legsipk'),
                legsisk: url.get('legsisk'),
                pid: url.get('pid')
            });
        }
    }, [search]);

    useEffect(() => {
        if (!props.dynamo) {
            const newPage = Number(page);
            if (isNaN(newPage) || newPage <= 0) return;

            if (newPage !== currentPage || (newPage === 1 && currentPage === 1 && !initialLoad)) {
                props.setCurrentPage(newPage);
                props.onPageChange(newPage);
                if (newPage === 1) setInitialLoad(true);
            }
        } else {
            if (!page || Object.keys(page).length === 0) return;

            const pid = Number(page?.pid);
            const validPid = pid > 0 && pid <= totalCount ? pid : 1;
            if (validPid !== currentPage) {
                props.setCurrentPage(validPid);
                props.onPageChange(validPid, page);
            }
        }
    }, [page]);

    const onNext = () => {
        if (!props.dynamo) setQueryParams(`?page=${currentPage + 1}`);
        else dynamoQuerySetter(currentPage + 1);
        props.setCurrentPage(currentPage + 1);
        props.onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        if (!props.dynamo) setQueryParams(`?page=${currentPage - 1}`);
        else dynamoQuerySetter(currentPage - 1);
        props.setCurrentPage(currentPage - 1);
        props.onPageChange(currentPage - 1);
    };

    const lastPage = paginationRange[paginationRange.length - 1];

    if (currentPage === 0 || totalCount < 1) {
        return <div>{props.children}</div>;
    }

    return (
        <div className="pagination-component">
            <div>{props.children}</div>
            <div className="pagination-component-wrapper">
                <hr />
                <ul className={classnames('pagination-container', { [className]: className })}>
                    <li
                        className={classnames('pagination-item', {
                            disabled: currentPage === 1
                        })}
                        onClick={onPrevious}
                    >
                        <i className="bi bi-chevron-left"></i>
                    </li>

                    {paginationRange.map((pageNumber, index) => {
                        if (pageNumber === DOTS) {
                            return <li style={{ pointerEvents: "none" }} className="pagination-item dots" key={index}>&#8230;</li>;
                        }

                        return (
                            <li
                                className={classnames('pagination-item', {
                                    selected: pageNumber === currentPage
                                })}
                                onClick={() => {
                                    if (!props.dynamo) {
                                        setQueryParams(`?page=${pageNumber}`);
                                    } else {
                                        dynamoQuerySetter(pageNumber);
                                    }
                                }}
                                key={index}
                                style={
                                    paginationRange[index - 1] === currentPage ||
                                        paginationRange[index + 1] === currentPage ||
                                        paginationRange[index] === 1
                                        ? {}
                                        : { pointerEvents: 'painted' }
                                }
                            >
                                {t('number_translate', { count: returnNumberByLang(pageNumber) })}
                            </li>
                        );
                    })}

                    <li
                        className={classnames('pagination-item', {
                            disabled: currentPage === lastPage
                        })}
                        onClick={onNext}
                    >
                        <i className="bi bi-chevron-right"></i>
                    </li>
                </ul>
                <hr />
            </div>
        </div>
    );
};

export default React.memo(CustomPagination);
